const BASE = "https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web";

export const NAVBAR_ASSETS = {
  logo: `${BASE}/v2/logo-propi.svg`,
  logoWhite: `${BASE}/v2/propi_white.svg`,
};
